/** Normaliza texto para comparação de busca (minúsculas, sem acentos). */
export function normalizeSearchText(value: string | null | undefined): string {
  if (value == null || value === "") return "";
  return value
    .toString()
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toLocaleLowerCase("pt-BR");
}

/** Verifica se `haystack` contém `needle`, ignorando acentos e maiúsculas/minúsculas. */
export function textIncludesSearch(
  haystack: string | null | undefined,
  needle: string | null | undefined,
): boolean {
  const q = normalizeSearchText(needle?.trim());
  if (!q) return true;
  return normalizeSearchText(haystack).includes(q);
}
